import { useQuery } from '@tanstack/react-query'
import { restaurantsApi } from '@/api/endpoints/restaurants'

export function useRestaurants() {
  return useQuery({
    queryKey: ['restaurants'],
    queryFn: restaurantsApi.list,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
